import { Separator, Stat, Text } from "@chakra-ui/react"
import Figure from "@hydrologiq/shared/figures/generic/Figure"
import FigureContent from "@hydrologiq/shared/figures/generic/FigureContent"

export interface PlaceholderProps {
  period: string
  description: string
  subText?: string
  error?: string
  loading?: boolean
  title?: string
}

function Placeholder({ period, description, subText, error, loading = false, title }: PlaceholderProps) {
  return (
    <Figure heading={title ?? "Comparison"} error={error} loading={loading}>
      <FigureContent.Root>
        <FigureContent.SubText>{period}</FigureContent.SubText>
        <FigureContent.Value>{description}</FigureContent.Value>
      </FigureContent.Root>
      {subText && (
        <>
          <Separator mb={1} />
          <FigureContent.Label>{subText}</FigureContent.Label>
        </>
      )}
    </Figure>
  )
}

export default Placeholder
